import { useContent } from '@/hooks/useContent';

export default function WhyUsSection() {
  const { t } = useContent('home');
  const { t: statT } = useContent('stats');
  const { t: imgT } = useContent('images');

  const bars = [
    { label: t('whyus_bar_customer'), value: parseInt(statT('whyus_bar_customer_value'), 10) || 100 },
    { label: t('whyus_bar_timely'), value: parseInt(statT('whyus_bar_timely_value'), 10) || 98 },
    { label: t('whyus_bar_reliable'), value: parseInt(statT('whyus_bar_reliable_value'), 10) || 99 },
    { label: t('whyus_bar_quality'), value: parseInt(statT('whyus_bar_quality_value'), 10) || 97 },
  ];

  return (
    <section className="overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[520px]">
        <div className="relative w-full lg:w-1/2 min-h-[340px] lg:min-h-[520px] bg-black flex items-center justify-center cursor-pointer group rounded-2xl overflow-hidden">
          <img
            alt="Completed insulation project by FMO LLC"
            className="w-full h-full object-cover object-center"
            src={imgT('whyus_image')}
          />
          <div className="absolute bottom-4 left-0 right-0 flex justify-center z-10">
            <span className="bg-black/60 text-white text-xs font-semibold px-4 py-1.5 rounded-full tracking-wide">FMO LLC — {t('whyus_badge')}</span>
          </div>
        </div>

        <div className="w-full lg:w-1/2 bg-background-50 flex flex-col justify-center px-8 md:px-16 py-14">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-primary-500 border border-primary-500/40 rounded-full px-4 py-1 mb-5 w-fit">
            {t('whyus_badge')}
          </span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-50 leading-snug mb-4">
            {t('whyus_title')}
          </h2>
          <p className="text-foreground-400 text-sm leading-relaxed mb-8 max-w-md">
            {t('whyus_desc')}
          </p>
          <div className="space-y-5">
            {bars.map((bar) => (
              <div key={bar.label}>
                <div className="flex justify-between items-center mb-1.5">
                  <span className="text-xs font-bold uppercase tracking-widest text-foreground-400">{bar.label}</span>
                  <span className="text-sm font-extrabold text-primary-500">{bar.value}%</span>
                </div>
                <div className="w-full bg-foreground-500/10 rounded-full h-2">
                  <div
                    className="h-2 rounded-full bg-gradient-to-r from-primary-900 to-primary-500 transition-all duration-1000 ease-out"
                    style={{ width: `${bar.value}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}